import { ComponentType, MemoExoticComponent, memo } from 'react';

/**
 * `deepMemo` Extended React.emo with deep array and object comparison, rather than ref check.
 * NOTE: This uses Json.stringify, so it's not performant for large objects, and requires items/objects to have props in the matching order. It will not compare function or symbol changes/
 */

const deepMemo = <T extends ComponentType<any>>(Component: T): MemoExoticComponent<T> => {
  const propsAreEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
  const MemoComponent = memo(Component, propsAreEqual);
  MemoComponent.displayName = 'deepMemo';
  return MemoComponent;
};

export default deepMemo;
